export enum InvalidValueType {
   Invalid = '___INVALID___'
}

export declare type DataTypeWithInvalid<T> = T | InvalidValueType | undefined;

export const InvalidValue = InvalidValueType.Invalid;

export const isInvalidValue = <T> (value: DataTypeWithInvalid<T>) => {
   return value === InvalidValue;
};

export const isValidValue = <T> (value: DataTypeWithInvalid<T>) => {
   return value !== InvalidValue;
};
